<template>
    <!-- Body Inner -->
    <div class="body-inner">
      <section class="container-login">
        <div class="container">
          <div class="row">
            <div class="col-md-6">
              <img src="assets/img/gca_logo.png" alt="Logo">
              <h3 class="login-text">
                  <span class="gca-title">¡Bienvenido(a) a Global Certification Academy!</span>
              </h3>
              <p class="gca-text">Si quieres conocer más sobre las diferentes certificaciones oficiales <a href="#" class="a-link"> da click aquí</a></p>
              <div class="card">
                <div class="card-body">
                  <h3 class="card-title mb-4">Inicia Sesión</h3>
                  <form class="row g-3">
                    <vue-form :state="formstate" @submit.prevent="onSubmit">
                      <div class="form-group">
                        <validate tag="div">
                          <input type="email" class="form-control" name="email" placeholder="Email" id="email" v-model="model.email" required>
                          <field-messages name="email" show="$invalid && $submitted" class="text-danger">
                              <div slot="required">El correo electrónico es requerido</div>
                              <div slot="email">El correo electrónico no es válido</div>
                          </field-messages>
                        </validate>
                      </div>
                      <div class="form-group">
                        <validate tag="div">
                          <input class="form-control" placeholder="Contraseña" type="password" id="password" name="password" minlength="8" required v-model="model.password">
                          <field-messages name="password" show="$invalid && $submitted" class="text-danger">
	                          <div slot="required">La contraseña es requerida</div>
	                          <div slot="minlength">La contraseña debe ser al menos de 8 caracteres</div>
	                        </field-messages>
                        </validate>                        
                      </div>
                      <div class="form-group">
                        <button type="submit" class="btn btn-primary">Login</button>
                        <p>¿No tienes una cuenta? <router-link to="/register" class="a-link ml-2">Registrate aquí</router-link></p>                 
                      </div>
                    </vue-form>
                  </form>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div id="image-carousel" class="splide carousel-login" aria-label="Beautiful Images">
                <div class="splide__track">
                  <ul class="splide__list">
                    <li class="splide__slide">
                      <img src="../assets/images/futuro_brillante.jpg" alt="">
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class="container">
          <ul class="nav nav-pills justify-content-center" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
                <button class="nav-link active" id="home-tab" data-bs-toggle="tab" href="#home-tab-pane" type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true">Inicio</button>
            </li>
            <li class="nav-item" role="presentation">
                <button class="nav-link" id="profile-tab" data-bs-toggle="tab" href="#profile-tab-pane" type="button" role="tab" aria-controls="profile-tab-pane" aria-selected="false">Paquetes</button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab">
              <div class="row mt-3">
                <div class="col-md-5">
                  <select class="form-select" aria-label="Default select example" v-model="product" @change="openPage">
                      <option selected>¿Cuál es la certificación que te interesa más?</option>
                      <option :value="`${producto.clave}`" v-for="producto in productosCatalogo" :key="producto.id">{{ producto.nombre }}</option>
                  </select>
                </div>
                <div class="col-md-5">
                  <select class="form-select" aria-label="Default select example">
                      <option selected>¿Cuál es la tu perfil de interés?</option>
                  </select>
                </div>
                <div class="col-md-2 d-grid gap-2">
                    <button type="button" class="btn btn-primary-gca">BUSCAR</button>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-6">
                  <img src="assets/images/conoce_mas.png" width="100%" alt="">
                </div>
                <div class="col-md-6 text-end">
                    <p class="gca-title">Conoce más sobre nosotros</p>
                    <p class="gca-text">Somos una plataforma con el único objetivo de ayudarte a transformarte en el profesional certificado que las empresas buscan. Nosotros ofrecemos <span class="gca-text-orange">certificaciones con respaldo de las diferentes marcas líderes de tecnología</span> de altos estándares a nivel mundial</p>
                    <p class="gca-text gca-text-orange">Somos la mejor opción para tu boleto al mundo de la tecnología</p>
                    <p class="gca-title">Prepárate, practica y certifícate</p>
                </div>
              </div>
              <div class="row mt-3 text-center">
                <div class="col-md-12">
                  <p class="gca-title">Certificaciones con prestigio internacional nos respaldan</p>
                </div>
                <div id="cert-carousel" class="splide" aria-label="Beautiful Images">
                  <div class="splide__track">
                    <ul class="splide__list">
                      <li class="splide__slide">
                        <img src="../assets/images/carousel/MOS_Sample_Certificate_1.png" alt="">
                      </li>
                      <li class="splide__slide">
                        <img src="../assets/images/carousel/MCE_Sample_Certificate.png" alt="">
                      </li>
                      <li class="splide__slide">
                        <img src="../assets/images/carousel/Sample_Certificate_ACP.png" alt="">
                      </li>
                      <li class="splide__slide">
                        <img src="../assets/images/carousel/ACA_Sample_Certificate.png" alt="">
                      </li>
                      <li class="splide__slide">
                        <img src="../assets/images/carousel/Adobe_Certified_Professional_Certificate.png" alt="">
                      </li>
                      <li class="splide__slide">
                        <img src="../assets/images/carousel/Autodesk_Sample_Certificate.png" alt="">
                      </li>
                      <li class="splide__slide">
                        <img src="../assets/images/carousel/Unity_Certified_User_Certificate.png" alt="">
                      </li>
                      <li class="splide__slide">
                        <img src="../assets/images/carousel/MTC_Certificate_2020.png" alt="">
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="profile-tab-pane" role="tabpanel" aria-labelledby="profile-tab">
              Paquetes
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class="container">
          <div class="row">
            <div class="col-md-12 text-center">
              <p class="gca-title-big">GCA se compromete al 100% en la calidad de los productos ya que contamos con certificaciones oficiales</p>
            </div>
            <div class="carousel client-logos dots-grey" data-items="5" data-arrows="false">
              <div>
                <a href="#"><img alt="" src="../assets/images/certificaciones/acp.png"></a>
              </div>
              <div>
                <a href="#"><img alt="" src="../assets/images/certificaciones/autodesk.png"></a>
              </div>
              <div>
                <a href="#"><img alt="" src="../assets/images/certificaciones/csb.png"></a>
              </div>
              <div>
                <a href="#"><img alt="" src="../assets/images/certificaciones/esb.png"></a>
              </div>
              <div>
                <a href="#"><img alt="" src="../assets/images/certificaciones/ic3.png"></a>
              </div>
              <div>
                <a href="#"><img alt="" src="../assets/images/certificaciones/its.png"></a>
              </div>
              <div>
                <a href="#"><img alt="" src="../assets/images/certificaciones/mos.png"></a>
              </div>
              <div>
                <a href="#"><img alt="" src="../assets/images/certificaciones/spark.png"></a>
              </div>
              <div>
                <a href="#"><img alt="" src="../assets/images/certificaciones/swift.png"></a>
              </div>
              <div>
                <a href="#"><img alt="" src="../assets/images/certificaciones/unity.png"></a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class="container">
          <div class="row">
            <div class="col-md-12 text-center">
              <p class="gca-title-big">Las nuevas problemáticas a las que se enfrentan los empleadores</p>
            </div>
            <div class="col-md-6 text-center mt-2">
              <img src="assets/images/porcentaje_1.png" alt="">
              <p class="gca-text">73% de las empresas tiene dificultades en encontrar trabajadores calificados.</p>
              <br>
            </div>
            <div class="col-md-6 text-center mt-2">
              <img src="assets/images/porcentaje_2.png" alt="">
              <p class="gca-text">61% de las empresas menciona que no puede encontrar suficientes trabajadores para expandir su negocio.</p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-8 mt-2 text-center">
              <p class="gca-title-extra-big">85</p><br>
              <p class="gca-text">Millones de trabajos calificados
                  estarán vacantes debido a una escasez mundial de talento en 2030 - equivalente al 11% de la fuerza laboral mundial.
              </p>
              <p>Korn Ferry - Asesoría Mundial de Recursos Humanos</p>
            </div>
            <div class="col-md-4 mt-2 text-center">
              <img src="assets/images/ThreeDee_Male.png" alt="">
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class="container">
          <div class="row">
            <div class="col-md-12 text-center">
                <p class="gca-title-big">¡Sé parte de un mundo de profesionales certificados!</p>
            </div>
            <div class="col-md-12 text-center">
              <video src="https://f002.backblazeb2.com/file/csb-eThinking/content-gca/videos/Como_ser_ATC_ETC.mp4" type="video/mp4" controls></video>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-md-4 text-center">
              <img src="assets/images/personas.png" alt="">
              <p class="gca-text">Más de 15,000 estudiantes inscritos</p>
            </div>
            <div class="col-md-4 text-center">
              <img src="assets/images/clase.png" alt="">
              <p class="gca-text">Más de 1,000 organizaciones</p>
            </div>
            <div class="col-md-4 text-center">
              <img src="assets/images/campus.png" alt="">
              <p class="gca-text">Más de 800 campus</p>
            </div>
          </div>
        </div>
      </section>
      <section class="container-testimonials">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <span class="gca-title-white">Nuestros alumnos nos recomiendan</span>
              <img class="mt-4" src="assets/images/Medallions.png" alt="">
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="card" style="width: 18rem;">
                <img src="assets/images/Avatar_1.png" class="card-img-top" alt="...">
                <div class="card-body">
                  <h5 class="card-title gca-text-orange">Rebecca</h5>
                  <p class="card-text">vitae sapien pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas sed tempus urna</p>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="card" style="width: 18rem;">
                <img src="assets/images/Avatar_2.png" class="card-img-top" alt="...">
                <div class="card-body">
                  <h5 class="card-title gca-text-orange">Eric</h5>
                  <p class="card-text">vitae sapien pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas sed tempus urna</p>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="card" style="width: 18rem;">
                <img src="assets/images/Avatar_3.png" class="card-img-top" alt="...">
                <div class="card-body">
                  <h5 class="card-title gca-text-orange">Sophie</h5>
                  <p class="card-text">vitae sapien pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas sed tempus urna</p>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="card" style="width: 18rem;">
                <img src="assets/images/Avatar_4.png" class="card-img-top" alt="...">
                <div class="card-body">
                  <h5 class="card-title gca-text-orange">Lorenzo</h5>
                  <p class="card-text">vitae sapien pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas sed tempus urna</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section></section>
      <section class="container-impact">
        <div class="container">
          <div class="row">
            <div class="col-md-8">
                <p class="gca-title-big">Impacto positivo de tener una certificación</p>
            </div>
            <div class="col-md-4">
                <div class="card" style="width: 18rem;">
                    <img src="assets/images/student.png" class="card-img-top" alt="...">
                    <div class="card-body text-center">
                        <h5 class="card-title gca-text-orange">61%</h5>
                        <p class="card-text">Impacto positivo en su imagen profesional </p>
                    </div>
                </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-md-4">
              <div class="card" style="width: 18rem;">
                <img src="assets/images/analyst.png" class="card-img-top" alt="...">
                <div class="card-body text-center">
                  <h5 class="card-title gca-text-orange">26%</h5>
                  <p class="card-text">Se mueven hacia una carrera de tecnología de la información</p>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card" style="width: 18rem;">
                <img src="assets/images/meeting.png" class="card-img-top" alt="...">
                <div class="card-body text-center">
                  <h5 class="card-title gca-text-orange">20%</h5>
                  <p class="card-text">Recibe un incremento salarial</p>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card" style="width: 18rem;">
                <img src="assets/images/handshake.png" class="card-img-top" alt="...">
                <div class="card-body text-center">
                  <h5 class="card-title gca-text-orange">19%</h5>
                  <p class="card-text">Encuentran un empleo</p>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-md-4">
              <div class="card" style="width: 18rem;">
                <img src="assets/images/city.png" class="card-img-top" alt="...">
                <div class="card-body text-center">
                  <h5 class="card-title gca-text-orange">18%</h5>
                  <p class="card-text">Sin beneficios profesionales</p>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card" style="width: 18rem;">
                <img src="assets/images/pen.png" class="card-img-top" alt="...">
                <div class="card-body text-center">
                  <h5 class="card-title gca-text-orange">14%</h5>
                  <p class="card-text">Obtien una promoción en la empresa</p>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card" style="width: 18rem;">
                <img src="assets/images/money.png" class="card-img-top" alt="...">
                <div class="card-body text-center">
                  <h5 class="card-title gca-text-orange">7%</h5>
                  <p class="card-text">Otros beneficios económicos</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section></section>
      <LeadComponent></LeadComponent>

      <footer-landing-component></footer-landing-component>
    </div>
</template>

<script>
	import options from "../validations/validations.js";
  import HeaderLandingComponent from "../components/Landing/HeaderLandingComponent.vue"
  import FooterLandingComponent from "../components/Landing/FooterLandingComponent.vue"
  import LeadComponent from "../components/Landing/LeadComponent.vue"
  import Splide from '@splidejs/splide';
	Vue.use(VueForm, options);
	export default {
		components: {
			HeaderLandingComponent,
      FooterLandingComponent,
      LeadComponent
		},    
		name: 'Index',
		data() {
			return {
				formstate: {},
        model: {
            email: "",
            password: ""
        },
        modelLead: {
          sName: '',
          sLastName: '',
          sEmail: '',
          sPhone: '',
          sComments: ''
        },
        productosCatalogo: [],
        product: '¿Cuál es la certificación que te interesa más?',
				//hostname: '',
				//backgroundUrl: 'background-image:url(assets/img/fondos/pro-login-bg.png); background-size:cover; background-repeat:no-repeat',
				//classLogin: 'card bg-gradient-default',
				//classUsuario: 'text-center text-muted mb-4',
				//classForgot: 'text-white'
			}
		},
		methods: {
			onSubmit() {
				if (this.formstate.$invalid) {
	                return;
	            } else {
	            	this.openLoading()
	            	axios.post(apiKS + 'api/login', this.model)
	            	.then( response => {
	            		if(response.data.id == 0 && response.data.token == '') {
	                        Swal.close()
	                        Swal.fire({
					        	icon: 'error',
					        	title: 'Oops...',
					        	text: response.data.message,
					        })
	                    }
	                    if(response.data.id > 0 && response.data.token != '') {
	                        Swal.close()
	                        localStorage.tokenETCSistema = 'Bearer ' + response.data.token
	                        headers = {
	                            'Content-Type': 'application/json',
	                            Authorization: localStorage.tokenETCSistema
	                        }
	                        axios.get(apiKS + 'api/user', { headers })
	                        .then( response => {
	                            localStorage.userETC = response.data.userEncrypted
	                            axios.post(apiKS + 'api/userdecrypt', {usuario: localStorage.userETC}, { headers })
	                            .then( response => {
                                user = JSON.parse(response.data.user)
                                if(this.$store.state.carrito.productos.length > 0) {
                                  axios.post(apiKS + 'api/crea-carrito', this.$store.state.carrito, { headers })
                                  .then( responseCarrito => {
                                      router.replace('/checkout')
                                  } )
                                  .catch(error => {
                                      this.catchError(error)
                                  })
                                }
                                if(user.tipo_usuario_pro == 1) 
                                  router.push('/home')
                                if(user.tipo_usuario_pro == 2) 
                                  router.push('/home-teacher')
	                            }).catch(error => {
	                                this.catchError(error)
	                            })
	                        })
	                    }
	            	}).catch(error => {
	            		this.catchError()
	            	})
	            }
			},
      openPage() {
        if(this.product == 'MOS')
          this.$router.push('/mos')
        if(this.product == 'Adobe')
          this.$router.push('/adobe')
        if(this.product == 'Autodesk')
          this.$router.push('/autodesk')
        if(this.product == 'CSB')
          this.$router.push('/csb')
        if(this.product == 'ESB')
          this.$router.push('/esb')
        if(this.product == 'IC3')
          this.$router.push('/ic3')
        if(this.product == 'ITS')
          this.$router.push('/its')
        if(this.product == 'Unity')
          this.$router.push('/unity')
        if(this.product == 'MCE')
          this.$router.push('/mce')
        if(this.product == 'PMI')
          this.$router.push('/pmi')
        if(this.product == 'Swift')
          this.$router.push('/swift')
        if(this.product == 'CISCO')
          this.$router.push('/cisco')
      }
		},
		async mounted() {
      new Splide( '#image-carousel' ).mount();
      new Splide( '#cert-carousel', {
        autoplay: true,
        interval: 3000
      } ).mount();
      await this.getProductosStore('api/productos?aparece_index=1')
      if(localStorage.tokenETCSistema) {
        if(this.$route.query.logout == 1) {
            this.$store.commit('setUsuario', null)
            this.$store.commit('setProductos', [])
            axios.get(apiKS + 'api/logout', { headers })
            .then(response => {
                if(response.data.status == true) {
                    localStorage.removeItem("tokenETCSistema")
                    localStorage.removeItem("userETC")
                }
            }).catch(error => {
                this.catchError(error)
            })
        }
        //else{
        //    headers = {
        //        'Content-Type': 'application/json',
        //        Authorization: localStorage.tokenETCSistema
        //    }
        //    axios.post(apiKS + 'api/userdecrypt', {usuario: localStorage.userETC}, { headers })
        //    .then( response => {
        //        user = JSON.parse(response.data.user)
        //        router.push('/productos')
        //    }).catch(error => {
        //        this.catchError(error)
        //    })
        //}
      }      
		},
		beforeMount() {

		}
	}
</script>
<style scoped>

</style>